import React from 'react';
import { Star } from 'lucide-react';
const REVIEWS = [{
  label: 'Window Glass Customer',
  quote: '[Paste real customer review here.]',
  name: '[Customer Name]',
  city: '[City]'
}, {
  label: 'Foggy Glass Customer',
  quote: '[Paste real customer review here.]',
  name: '[Customer Name]',
  city: '[City]'
}, {
  label: 'Shower Glass Customer',
  quote: '[Paste real customer review here.]',
  name: '[Customer Name]',
  city: '[City]'
}];
const PROOF_ITEMS = ['Free In-Home Estimates', 'Glass-Only Window Replacement', 'Broken & Foggy Window Glass', 'Warranty-Backed Work'];
export function Reviews() {
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-white border-t border-slate-100" aria-labelledby="reviews-heading" data-id="element-207">
      <div className="max-w-7xl mx-auto" data-id="element-208">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-209">
          <h2 id="reviews-heading" className="text-3xl sm:text-4xl font-bold text-navy-900 tracking-tight mb-4" data-id="element-210">
            What Customers Say About Kosin’s Glass
          </h2>
          <p className="text-lg text-slate-600" data-id="element-211">
            Homeowners count on Kosin’s Glass for broken window repair, foggy
            glass replacement, door glass, mirrors, shower glass and custom
            residential glass.
          </p>
        </div>

        <ul className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-212">
          {REVIEWS.map((review, idx) => <li key={idx} data-id="element-213">
              <figure className="bg-slate-50 rounded-2xl p-6 sm:p-7 border border-slate-100 shadow-soft flex flex-col h-full anim-on-scroll" data-id="element-214">
                <div className="flex items-center gap-1 text-amber-500 mb-4" aria-label="5-star review" data-id="element-215">
                  <Star className="w-4 h-4 fill-amber-500" data-id="element-216" />
                  <Star className="w-4 h-4 fill-amber-500" data-id="element-217" />
                  <Star className="w-4 h-4 fill-amber-500" data-id="element-218" />
                  <Star className="w-4 h-4 fill-amber-500" data-id="element-219" />
                  <Star className="w-4 h-4 fill-amber-500" data-id="element-220" />
                  <span className="sr-only" data-id="element-221">5-star review</span>
                </div>
                <blockquote className="text-slate-700 leading-relaxed italic flex-grow" data-id="element-222">
                  “{review.quote}”
                </blockquote>
                <figcaption className="mt-5 pt-4 border-t border-slate-200" data-id="element-223">
                  <div className="font-semibold text-navy-900 not-italic" data-id="element-224">
                    {review.name}
                  </div>
                  <div className="text-sm text-slate-500 not-italic" data-id="element-225">
                    {review.city} · {review.label}
                  </div>
                </figcaption>
              </figure>
            </li>)}
        </ul>

        <div className="bg-navy-900 rounded-2xl py-5 px-6" data-id="element-226">
          <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-slate-100" data-id="element-227">
            {PROOF_ITEMS.map((item, idx) => <li key={idx} className="flex items-center gap-2 text-sm sm:text-base font-semibold" data-id="element-228">
                <span className="w-1.5 h-1.5 rounded-full bg-brandBlue-500" aria-hidden="true" data-id="element-229" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}